import script from "./EventItems.vue?vue&type=script&setup=true&lang=js"
export * from "./EventItems.vue?vue&type=script&setup=true&lang=js"

import "./EventItems.vue?vue&type=style&index=0&id=7ae205d3&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae205d3"]])

export default __exports__